import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  return (
    <div className="px-4 md:px-10 shadow-custom">
      <nav className="flex justify-between items-center">
        <div>
          <img
            src="./assets/images/logo.png"
            alt="logo"
            className="w-14"
          />
        </div>
        <ul className="text-sm md:text-md flex font-nunito md:pr-16">
          <li className="mx-6">
            <NavLink to="/">
              <span
                className={
                  location.pathname === '/'
                    ? 'transition ease-out duration-300 hover:text-primary-100 underline underline-offset-8'
                    : 'transition ease-out duration-300 hover:text-primary-100'
                }
              >
                COMMANDER
              </span>
            </NavLink>
          </li>
          <li className="mx-6">
            <NavLink to="/a-propos">
              <span
                className={
                  location.pathname === '/a-propos'
                    ? 'transition ease-out duration-300 hover:text-primary-100 underline underline-offset-8'
                    : 'transition ease-out duration-300 hover:text-primary-100'
                }
              >
                A PROPOS
              </span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
